define([
	"./_Color",
	"./PluginFactory",
	"./util"
], function(_Color, PluginFactory, util) {

	return PluginFactory.declare(_Color, {
		"class": "csi-color-icon csi-text-formatting-select-button-no-border",
		propertyKey: "spPr.ln.fill.color",
		materialIcon: "border_color",
		pluginName: "stroke",
		title: "CanvasLineColor",

		/**
		 * Set color style
		 * @param  {String} color
		 */
		onColor: function(color) {
			this.editor.setShapeProperty(util.shapeProperties.strokeColor, color);
		}
	});
});
